import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment-timezone';

import { useLocation, useNavigate } from 'react-router-dom';

import { Slider, Radio, Checkbox, RadioGroup, FormGroup, FormControlLabel, FormControl } from '@mui/material';

import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import "./AssignmentView.css";

function AssignmentView(props) {
    const [form, setForm] = useState({});
    const [group, setGroup] = useState([]);
    const [formMessage, setFormMessage] = useState("");
    const [isCompleted, setIsCompleted] = useState(false);

    const { state } = useLocation();
    const navigate = useNavigate();

    async function submitForm(event) {
        event.preventDefault();
        let assignment = form;
        for (let i = 0; i < assignment.questions.length; i++) {
            let question = assignment.questions[i];
            if (question.type === "group_survey") {
                if (Array.isArray(question.response))
                    question.response = {};
                for (let j = 0; j < group.length; j++) {
                    if (!question.response.hasOwnProperty(group[j].user_id))
                        question.response[group[j].user_id] = 5;
                }
            }
        }

        if (state.assignment.is_completed) {
            await axios.put(`${process.env.REACT_APP_API_HOST}/api/forms/assignments/responses`, 
                {
                    assigment: form
                },
                { headers: {Authorization: `Bearer ${state.token.access_token}`}}
            );
        } else {
            await axios.post(`${process.env.REACT_APP_API_HOST}/api/forms/assignments/responses`, 
                {
                    assigment: form
                },
                { headers: {Authorization: `Bearer ${state.token.access_token}`}}
            );
            state.assignment.is_completed = true;
        }
        setFormMessage("Assignment has been submitted");
        navigate("/student");
    }

    function handleResponseChange(questionIndex, response) {
        let updatedForm = form;
        updatedForm.questions[questionIndex].response = [response];
        setForm({...updatedForm});
    }

    function handleMultipleSelectChange(questionIndex, answerIndex, response) {
        let updatedForm = form;
        if (response) {
            updatedForm.questions[questionIndex].response.push(answerIndex);
        }
        else {
            let index = updatedForm.questions[questionIndex].response.indexOf(answerIndex);
            updatedForm.questions[questionIndex].response.splice(index, 1);
        }
        setForm({...updatedForm});
    }

    function handleGroupSurveyChange(questionIndex, user_id, value) {
        let updatedForm = form;
        updatedForm.questions[questionIndex].response = {
            ...updatedForm.questions[questionIndex].response,
            [user_id]: value,
        };
        setForm({...updatedForm});
    }

    useEffect(() => {
        async function loadForm() {
            const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/forms/assignments/${state.assignment.assignment_id}/response`,
                { headers: { Authorization: `Bearer ${state.token.access_token}`} }
            )
            let formData = response.data;
            let start = moment.utc(formData.start, moment.ISO_8601, true);
            let end = moment.utc(formData.end, moment.ISO_8601, true);
            formData.start = start.local().format("dddd, MMMM Do YYYY, h:mm a");
            formData.end = end.local().format("dddd, MMMM Do YYYY, h:mm a");
            setForm(formData);
            setIsCompleted(state.assignment.is_completed);
        }

        async function loadGroup() {
            const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/groups/findGroup`,
                { headers: { Authorization: `Bearer ${state.token.access_token}`} }
            )
            setGroup(response.data.members);
        }
    
        loadForm();
        loadGroup()
    }, [])
    

    return (
        <>
            <DashboardNavbar />
            <div style={{display: "flex", justifyContent: "space-around", alignItems: "center"}}>
                <h2 className="title">{form.name}</h2>
                <div>
                    <p>{"Start: " + form.start}</p>
                    <p>{"End: " + form.end}</p>
                </div>
            </div>
            <form className="assignment-form" onSubmit={submitForm}>
                {
                    form.questions && form.questions.map((question, index) => (
                        question.type === "free_response" ? 
                        <div key={"q"+index} className="question">
                            <p>Type: Free Response</p>
                            <h4>{question.text}</h4>
                            <div className="answer">
                                <textarea type="text" rows="4" value={question.response[0]} onChange={(event) => handleResponseChange(index, event.target.value)} required />
                            </div>
                        </div>
                        : question.type === "likert" ? 
                        <div key={"q"+index} className="question">
                            <p>Type: Likert</p>
                            <h4>{question.text}</h4>
                            <FormControl className="answer">
                                <RadioGroup
                                    row
                                    aria-labelledby={question.text}
                                    name={"q"+index}
                                    value={question.response[0] !== undefined ? question.response[0] : null}
                                    onChange={(event) => handleResponseChange(index, parseInt(event.target.value))}
                                >
                                    <FormControlLabel value={2} control={<Radio required={true} />} label="Strongly Agree" labelPlacement="top"/>
                                    <FormControlLabel value={1} control={<Radio required={true} />} label="Agree" labelPlacement="top"/>
                                    <FormControlLabel value={0} control={<Radio required={true} />} label="Neutral" labelPlacement="top"/>
                                    <FormControlLabel value={-1} control={<Radio required={true} />} label="Disagree" labelPlacement="top"/>
                                    <FormControlLabel value={-2} control={<Radio required={true} />} label="Strongly Disagree" labelPlacement="top"/>
                                </RadioGroup>
                            </FormControl>
                        </div>
                        : question.type === "multiple_choice" ? 
                        <div key={"q"+index} className="question">
                            <p>Type: Multiple Choice</p>
                            <h4>{question.text}</h4>
                            <RadioGroup
                                className="answer"
                                aria-labelledby={question.text}
                                name={"q"+index}
                                value={question.response[0] !== undefined ? question.response[0] : null}
                                onChange={(event) => handleResponseChange(index, parseInt(event.target.value))}
                                required
                            >
                            {
                                question.answers.map((answer, aIndex) => (
                                    <FormControlLabel key={"q"+index+"a"+aIndex} value={aIndex} control={<Radio required={true} />} label={answer} />
                                ))
                            }
                            </RadioGroup>
                        </div>
                        : question.type === "multiple_select" ?
                        <div key={"q"+index} className="question">
                            <p>Type: Multiple Select</p>
                            <h4>{question.text}</h4>
                            <FormGroup className="answer" required>
                            {
                                question.answers.map((answer, aIndex) => (
                                    <FormControlLabel
                                    key={"q"+index+"a"+aIndex}
                                    control={
                                        <Checkbox checked={question.response.includes(aIndex)} onChange={(event) => handleMultipleSelectChange(index, aIndex, event.target.checked)} />
                                    }
                                    label={answer}
                                />
                                ))
                            }
                            </FormGroup>
                        </div>
                        : question.type === "group_survey" ?
                        <div key={"q"+index} className="question">
                            <p>Type: Group Survey</p>
                            <h4>{question.text}</h4>
                            {
                                group?.map((user) => (
                                    <div key={user.user_id} style={{display: "flex", alignItems: "baseline", gap: 16, paddingRight: "21px"}}>
                                        <p style={{flex: 1}}>{user.first_name + " " + user.last_name}</p>
                                        <Slider
                                            aria-label="sample-answer"
                                            value={question.response[user.user_id] === undefined ? 5 : question.response[user.user_id]}
                                            valueLabelDisplay="auto"
                                            sx={{flex: 1}}
                                            onChange={(event, value) => handleGroupSurveyChange(index, user.user_id, value)}
                                            marks={[{value: 0, label: "0"}, {value: 5, label: "5"}, {value: 10, label: "10"}]}
                                            step={1}
                                            min={0}
                                            max={10}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                        : null
                    ))
                }
                <div className="footer">
                    <div>
                        <p>{formMessage}</p>
                        <button type="submit">{isCompleted ? "Resubmit Assignment" : "Submit Assignment"}</button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AssignmentView;